// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginPoster_container_1ljzD","logo":"LoginPoster_logo_3EMMJ","information":"LoginPoster_information_2g66r"};